module.exports = __webpack_public_path__ + "static/media/03- Welcome.a42e1b81.png";